import { useCallback } from 'react'

import { Navbar as BaseNavbar, Navbar2 as BaseNavbar2 } from 'decentraland-dapps/dist/containers'
import { isEmpty } from 'lodash'

import { config } from '../../config/config'
import useDclProfile from '../../hooks/useDclProfile'

import './Navbar.css'
import { Props } from './Navbar.types'

const AUTH_URL = config.get('AUTH_URL')

export default function Navbar(props: Props) {
  const { address, isConnected } = props
  const { profile, isLoadingDclProfile } = useDclProfile(address)
  const hasProfile = !isEmpty(profile)

  const handleSignIn = useCallback(() => {
    window.location.replace(`${AUTH_URL}?redirectTo=${window.location.href}`)
  }, [])

  if (props.isNavbar2Enabled) {
    return (
      <div className="Navbar">
        {/* Navbar2 is a connected container — avatar/sign-in state come from the dapps store; don't pass them by hand. */}
        <BaseNavbar2 identity={props.identity} onSignIn={handleSignIn} withNotifications={false} />
      </div>
    )
  }

  return (
    <BaseNavbar
      {...props}
      onSignIn={handleSignIn}
      withNotifications={false}
      activePage="governance"
      avatar={hasProfile ? profile : undefined}
      isSignedIn={isConnected && hasProfile}
      isSigningIn={isLoadingDclProfile}
    />
  )
}
